export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-8 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="relative overflow-hidden rounded-2xl bg-background-100 border border-background-200/70">
          <div className="flex flex-col lg:flex-row items-center gap-8 p-8 md:p-12">
            <div className="flex-1 w-full">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4 whitespace-nowrap">
                <i className="ri-mail-send-line"></i>
                联系我们
              </div>

              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
                你的声音，我们认真倾听
              </h2>

              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-lg">
                无论你是有影片推荐、片源反馈，还是想要合作交流，欢迎随时与我们联系。成全影视团队重视每一位用户的声音，我们会及时回复你的每一条留言。版权相关事宜也请通过下方渠道沟通。
              </p>

              <div className="space-y-3">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-primary-500 text-lg"></i>
                  </div>
                  <div>
                    <p className="text-xs text-foreground-500">商务合作 / 版权沟通</p>
                    <p className="text-sm font-medium text-foreground-800 whitespace-nowrap">contact@chengquan.video</p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-chat-smile-2-line text-accent-500 text-lg"></i>
                  </div>
                  <div>
                    <p className="text-xs text-foreground-500">影视推荐 / 片源反馈</p>
                    <p className="text-sm font-medium text-foreground-800 whitespace-nowrap">feedback@chengquan.video</p>
                  </div>
                </div>
              </div>

              <a
                href="mailto:contact@chengquan.video"
                className="inline-flex items-center gap-2 mt-6 px-5 py-2.5 rounded-lg bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium whitespace-nowrap cursor-pointer transition-colors duration-200"
              >
                <i className="ri-send-plane-line"></i>
                发送邮件
              </a>
            </div>

            <div className="flex-1 w-full flex justify-center">
              <div className="relative w-full max-w-[400px] aspect-square rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20warm%20cinema%20lobby%20with%20soft%20ambient%20lighting%2C%20movie%20posters%20on%20walls%2C%20elegant%20decor%2C%20cozy%20atmosphere%2C%20modern%20minimalist%20style%2C%20warm%20crimson%20and%20gold%20accents%2C%20no%20people%2C%20no%20text&width=800&height=800&seq=contact-cinema&orientation=squarish"
                  alt="成全影视 - 联系我们"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/25 via-transparent to-transparent"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}